import { useRouter } from 'next/router';

export const useIsAppointmentPath = () => {
  const router = useRouter();
  return !!router.pathname.match(/\/booking([/?].*)?$/);
};
